import BaseCommand from "@/models/api/commands/BaseCommand";
import { CONTRACTOR_TYPES } from "@/static/contractorTypes";

export interface ChargeFromContractor {
  ContractorType: CONTRACTOR_TYPES;
  IsSelected: boolean;
}

export class SetChargeFromCustomContractorCommand extends BaseCommand {
  CommandName = "SetChargeFromCustomContractor";
  Command: ChargeFromContractor;

  constructor(sessionId: string, operationId: string, command: ChargeFromContractor) {
    super(sessionId, operationId);
    this.Command = command;
  }
}
